import { actions, FeatureFlagState, getters, mutations, state } from "@torre-labs/feature-flag";
import { Module } from "vuex";

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
} as Module<FeatureFlagState, any>;
